import React from 'react'
import { Button, Layout } from 'antd'
import {
    InstagramOutlined,
    FacebookOutlined,
    TikTokOutlined,
    YoutubeOutlined,
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import {
    getContentLinks,
    getAboutLinks,
    getCommunityLinks,
    getDocLinks,
} from './footerLinksData'
import FooterLinks from './FooterLinks'
import GooglePlayButton from '../Common/Buttons/GooglePlayButton'
import AppleStoreButton from '../Common/Buttons/AppleStoreButton'
import { useSmartNavigate } from '../../hooks/useSmartNavigate'
import './Footer.css'

const { Footer } = Layout

interface FooterModuleProps {
    onContactUsClick: () => void
}

const socialMediaIcons = [
    {
        icon: <TikTokOutlined />,
        url: 'https://www.tiktok.com/@dailyventsofficial',
    },
    {
        icon: <InstagramOutlined />,
        url: 'https://www.instagram.com/dailyventsofficial',
    },
    {
        icon: <FacebookOutlined />,
        url: 'https://www.facebook.com/dailyventsofc',
    },
    {
        icon: <YoutubeOutlined />,
        url: 'https://www.youtube.com/@dailyventsofficial',
    },
]

const FooterModule: React.FC<FooterModuleProps> = ({ onContactUsClick }) => {
    const { t } = useTranslation()
    const smartNavigate = useSmartNavigate()

    return (
        <Footer className="footer">
            <div className="footer-container">
                {/* Logo placeholder */}
                <div className="logo-container">
                    <img
                        className="logo"
                        src="/img/DailyVents_logo.svg"
                        alt={t('common.alt.dailyVentsLogo')}
                        onClick={() => smartNavigate('/')}
                        style={{ cursor: 'pointer' }}
                    />
                </div>

                {/* Site map */}
                <div className="site-map">
                    {/* 3 columns of text buttons, commented stuff is not part of first release */}
                    <div className="column-group">
                        <div className="column">
                            <FooterLinks links={getContentLinks(t)} />
                        </div>

                        <div className="column">
                            <FooterLinks links={getCommunityLinks(t)} />
                        </div>

                        <div className="column">
                            <FooterLinks links={getDocLinks(t)} />
                        </div>

                        <div className="column">
                            <FooterLinks links={getAboutLinks(t)} />
                        </div>
                    </div>

                    {/* Store buttons on far right */}
                    <div className="store-buttons">
                        <AppleStoreButton />
                        <GooglePlayButton />
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="bottom-bar">
                    <div className="copyright" style={{ color: '#000' }}>
                        {t('footer.copyright')}
                    </div>
                    <div className="social-media">
                        {socialMediaIcons.map((icon) => (
                            <Button
                                type="text"
                                icon={icon.icon}
                                key={icon.url}
                                onClick={() => window.open(icon.url, '_blank')}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </Footer>
    )
}

export default FooterModule
